import './Legal.css';

export default function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <span className="legal-tag">Legal</span>
          <h1>Privacy Policy</h1>
          <p className="legal-meta">Electradez LLC · Effective Date: March 14, 2025 · Colorado, USA</p>
        </div>

        <div className="legal-body">
          <section>
            <h2>1. Who We Are</h2>
            <p>Electradez LLC ("Electradez," "we," "us," or "our") is a Colorado limited liability company operating the Electradez marketplace platform at electradez.com. We connect buyers and sellers of electric motorcycles and related parts and accessories.</p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>Information you provide directly</h3>
            <ul>
              <li>Account registration details (name, email address, password)</li>
              <li>Profile information (profile photo, bio, location)</li>
              <li>Listing content (photos, descriptions, pricing, location)</li>
              <li>Messages sent to other users through our platform</li>
            </ul>
            <h3>Information collected automatically</h3>
            <ul>
              <li>Device and browser information (IP address, browser type, operating system)</li>
              <li>Usage data (pages visited, features used, time spent)</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Create and manage your account</li>
              <li>Display and manage your listings</li>
              <li>Facilitate communication between buyers and sellers</li>
              <li>Improve and personalize the platform</li>
              <li>Send transactional emails and service updates</li>
              <li>Detect and prevent fraud or abuse</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>4. How We Share Your Information</h2>
            <p>We do not sell your personal information. We may share your information with:</p>
            <ul>
              <li><strong>Service providers</strong> — third-party vendors who help us operate our platform (e.g., Supabase for database and authentication, Vercel for hosting)</li>
              <li><strong>Other users</strong> — your public listing information, username, and general location are visible to other users of the platform</li>
              <li><strong>Legal authorities</strong> — if required by law or to protect the rights and safety of our users</li>
            </ul>
          </section>

          <section>
            <h2>5. Cookies</h2>
            <p>We use cookies and similar technologies to keep you logged in, remember your preferences, and understand how you use our platform. You can control cookies through your browser settings. See our Cookie Policy for more details.</p>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>We retain your personal information for as long as your account is active or as needed to provide services. You may request deletion of your account and associated data by contacting us at the email below.</p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>Depending on your location, you may have the right to access, correct, or delete your personal information. To exercise these rights, contact us at <a href="mailto:privacy@electradez.com">privacy@electradez.com</a>.</p>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>Electradez is not directed at children under the age of 13. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child, please contact us immediately.</p>
          </section>

          <section>
            <h2>9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page with an updated effective date.</p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, contact us at:<br />
            <strong>Electradez LLC</strong><br />
            Colorado, USA<br />
            <a href="mailto:privacy@electradez.com">privacy@electradez.com</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
